import theme from "@chakra-ui/theme";

export default {
  ...theme,
  colors: {
    ...theme.colors,
    brand: {
      grey: "#f6f5f5",
      lightBlue: "#145374",
      darkBlue: "#00334e",
      peach: "#ee6f57",
      accent: "#DE3C4B",
      background: "#121212",
      text: "#FFFfff",
    },
  },
  fontSizes: {
    xs: "12px",
    sm: "14px",
    md: "16px",
    lg: "18px",
    xl: "20px",
    "2xl": "24px",
    "3xl": "28px",
    "4xl": "36px",
    "5xl": "48px",
    "6xl": "64px",
  },
};
